import { useEffect, useMemo } from "react";
import Particles from "@tsparticles/react";
import type { IParticlesProps } from "@tsparticles/react";
import type { ISourceOptions } from "@tsparticles/engine";
import { tsParticles } from "@tsparticles/engine";
import { loadFireworksPreset } from "@tsparticles/preset-fireworks";

export const ParticleBg = ({ id, options, ...props }: IParticlesProps) => {
	const particleOptions: ISourceOptions = useMemo(() => options, [options])!;

	useEffect(() => {
		(async () => {
			await loadFireworksPreset(tsParticles);

			await tsParticles.load({
				id,
				options: particleOptions,
			});
		})();
	}, [id, particleOptions]);

	return <Particles id={id} {...props} />;
};
